import React from "react";
import { compose, withProps } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";
import { GOOGLE_MAP_API_KEY } from "../../../../../api/config";

const LocationMap = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&v=3.exp&libraries=geometry,drawing,places`,
    loadingElement: <div style={{ height: `100%` }} />,
    mapElement: <div style={{ height: `100%` }} />
  }),
  withScriptjs,
  withGoogleMap
)(props => {
  return (
    <GoogleMap
      defaultZoom={props.zoom}
      defaultCenter={props.position}
      options={{
        disableDefaultUI: true,
        disableDoubleClickZoom: true,
        zoomControl: false,
        minZoom: 15,
        maxZoom: 15
      }}
    >
      {props.position ? <Marker position={props.position} /> : null}
    </GoogleMap>
  );
});

export default LocationMap;



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Steps/DrawerContent/LocationMap.js